export namespace ReferenceConst
{
  export const FAQCategoryIdTranfers: number = 11;
  export const ChatButtonId: string = 'liveagent_button_online_5738F000000GmdD';
  export const PersonalBrandComboPromo: string = "personal.brand.combo.id";

  export const WhatsAppUrl: string = 'https://wa.me/5218129089830';
  export const WhatsAppUrlAkkyPro: string = 'https://wa.me/5218129089830';
  export const BlogAkkyUrl: string = 'https://blog.akky.mx/';
  export const AccreditationPage: string = 'https://produs-ccs-assurancecard-service.sgsonline.net/assurancecard/be8e7fbc4499573f9c0088ceb276469123c1f835bb60c9e55a69d9d17925431e/assurancecard';
  export const GoogleMapsURL = 'https://www.google.com/maps/place/Akky+Online+Solutions/@25.6539925,-100.2766807,19z/data=!4m6!3m5!1s0x8662bfe1ae1939bf:0xaf96d41d2fc65a23!8m2!3d25.6537797!4d-100.2767987!16s%2Fg%2F11nx26r6c9?entry=ttu';

  export const NICMexicoHem = 'https://beta.nicmexico.mx/hecho-en-mexico';

  export const HelpCenterAkkyUrl: string = 'https://soporte.akky.mx/sitioayuda2/s/';
  export const HelpCenterAkkyTopicsUrl: string = 'https://soporte.akky.mx/sitioayuda2/s/temas-de-ayuda/';
  export const HelpCenterAkkyFAQUrl: string = '?articleId=kA0Pb000000TQjtKAG';
  export const HelpCenterAkkySupportUrl: string = '?articleId=kA0Pb000000TYZNKA4';
  export const HelpCenterAkkyTransferUrl: string = '?articleId=kA0Pb000000SqV7KAK';
  export const HelpCenterAkkyDomainRegisterUrl: string = '?articleId=kA0Pb000000SkmHKAS';
  export const HelpCenterAkkyIcannAcreditationUrl: string = '?articleId=kA0Pb000000TYW9KAO';

  export const HelpCenterAkkyUserCreateUrl: string = '?articleId=kA0Pb000000SoOTKA0';
  export const HelpCenterAkkyRegistrantContactUrl: string = '?articleId=kA0Pb000000V5EjKAK';
  export const HelpCenterAkkyInitialConfigSiteUrl: string = '?articleId=kA0Pb000000U2UDKA0';

}

